import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import Builder from './Builder';
import Player from './Player';
import CRM from './CRM';

const RotaProtegida = ({ children }) => {
  const token = localStorage.getItem('unity_token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Rota Pública do Formulário */}
        <Route path="/f/:id" element={<Player />} />

        {/* Rota Pública de Login */}
        <Route path="/" element={<Login />} />

        {/* Rotas Protegidas */}
        <Route path="/dashboard" element={<RotaProtegida><Dashboard /></RotaProtegida>} />
        <Route path="/builder/:id" element={<RotaProtegida><Builder /></RotaProtegida>} />
        <Route path="/crm/:id" element={<RotaProtegida><CRM /></RotaProtegida>} />

      </Routes>
    </BrowserRouter>
  );
}